module.exports = __webpack_public_path__ + "img/10n@2x.c8cdb216.svg";